/**
 * Adds request-context for Vision AI questions on campaign detail pages,
 * so Vision AI knows which campaign and date range the user is looking at.
 */

import { computed } from 'vue';

import { useCampaignsStore } from '@/stores/campaigns';

export function useCampaignVisionAiRequestContext() {
  const campaignsStore = useCampaignsStore();

  const requestContextFilters = computed<Record<string, unknown>>(() => {
    const dateRange = campaignsStore.dateRange as string[] | null;
    if (dateRange?.length !== 2) return {};

    return {
      sourceCreatedOnOrAfter: dateRange[0],
      sourceCreatedOnOrBefore: dateRange[1],
    };
  });

  const requestContextExtra = computed<Record<string, unknown>>(() => ({
    campaign_id: (campaignsStore.campaign as { id: number }).id,
  }));

  return { requestContextFilters, requestContextExtra };
}
